export default {
  domainDirectory: {
    title: "Официальные домены", subtitle: "Проверяйте официальные адреса здесь. Нажмите, чтобы скопировать.", available: " доступны",
    loading: "Загрузка доменов…", loadFailed: "Не удалось загрузить домены", retry: "Обновить", empty: "Нет активных доменов",
    tapToCopy: "Нажмите, чтобы скопировать", checking: "Проверка", checkingShort: "Проверка", online: "Доступен", offline: "Время ожидания подключения истекло",
    waiting: "Ожидание проверки", timeout: "Тайм-аут", testAll: "Проверить все домены", updatedEveryFifteenSeconds: "Подключение автоматически проверяется каждые 15 секунд",
    saveReminder: "Сделайте снимок этой страницы, чтобы сохранить данные доменов", copied: "Домен скопирован",
    names: { primary: "Основной домен", chinaAccel: "Ускорение для Китая", secondary: "Дополнительный домен" },
  },
  nickname: {"edit": "Изменить никнейм", "hint": "2–20 китайских/английских букв, цифр или _", "saved": "Никнейм сохранён", "taken": "Этот никнейм уже занят", "invalid": "Используйте 2–20 китайских/английских букв, цифр или _. Зарезервированные имена недоступны.", "failed": "Не удалось сохранить. Попробуйте ещё раз."},
  common: {
    confirm: "Подтвердить",
    cancel: "Отмена",
    search: "Поиск",
    language: "Язык",
    switched: "Переключено",
    currentLanguage: "Текущий язык",
    selectLanguage: "Выберите язык",
    loading: "Загрузка...",
    loadingMore: "Загрузка ещё...",
    noMoreData: "Больше данных нет",
    noData: "Нет данных",
    serverUnavailable: "Сервер временно недоступен",
    loadFailed: "Ошибка загрузки",
    requestFailed: "Ошибка запроса",
    projectName: "PANTA MARKET",
    duplicateSubmission: "Пожалуйста, не отправляйте повторно",
    fee: "Комиссия",
    tip: "Уведомление",
    connecting: "Подключение...",
    connectWalletFirst: "Сначала подключите кошелёк",
    connect: "Подключить",
    insufficientBalance: "Недостаточно средств",
    developing: "Функция в разработке",
    copyFailed: "Не удалось скопировать",
    sessionAuthRelogin: "Войти снова",
    sessionAuthStay: "Остаться",
    pleaseRelogin: "Сессия истекла, войдите снова",
    retry: "Нажмите, чтобы повторить",
    submit: "Отправить",
    pager: {
      prevPage: "Назад",
      nextPage: "Далее",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Перейти",
      jumpConfirm: "ОК",
    },
  },
  tabbar: {
    home: "Главная",
    market: "Лента",
    timeline: "Лента",
    prediction: "AI прогноз событийного контракта",
    createMarket: "Создать рынок",
    planet: "Планета",
    trade: "Торговля",
    finance: "Финансы",
    fund: "Фонд",
    assets: "Активы",
    planethistory: "История"
  },
  tradeMenu: {
    contract: "Событийный контракт",
    insurance: "Страхование",
    spot: "Спот",
    flash: "Быстрый обмен"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI-прогноз · Событийные контракты · Умный анализ",
    predictionCategories: {
      hot: "Лента",
      sports: "Спорт",
      world: "Мир",
      politics: "Политика",
      economy: "Экономика"
    },
    predictionSubCategories: {
      crypto: "Спот",
      forex: "Форекс",
      commodities: "Товары"
    },
    features: {
      recharge: "Пополнить",
      rechargeDesc: "Быстрый депозит",
      contract: "Контракт на событие",
      contractDesc: "Инновационные финансовые инструменты",
      predict: "AI-прогноз",
      fund: "PANTA MARKET Treasury",
      invite: "Пригласить друзей",
      global: "Глобальные узлы"
    },
    insurance: {
      title: "Страховой пул контрактов (TAKER)",
      aiPoolTitle: "Пул ИИ-страхования",
      ordinaryPoolTitle: "Пул обычного страхования",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (справ.)",
      more: "Узнать больше",
      yesterday: "Добавлено вчера",
      service: "Умный сервис"
    },
    market: {
      tabs: {
        main: "Основные",
        hot: "Популярные",
        rise: "Лидеры роста",
        price: "Цена"
      },
      headers: {
        pair: "Пара",
        latest: "Последняя цена",
        change: "Изм. за 24ч"
      },
      viewMore: "Смотреть еще",
      collapse: "Свернуть"
    },
    announcement: {
      title: "Объявление",
      heading: "Объявление",
      text: "Добро пожаловать на PANTA MARKET. Здесь вы познакомитесь с уникальной системой AI и страхования прогнозов, созданной PANTA MARKET, которая позволит вам легко присоединиться к рынку прогнозов WEB3 и начать свой путь к богатству.",
      time: "2025/11/19 10:00",
      gotIt: "Понятно",
      viewDetail: "Подробнее",
      systemLabel: "Системное объявление"
    },
    timePeriods: {
      "1min": "1 минута",
      "30min": "30 минут",
      "1hour": "1 час"
    },
    footer: {
      australia: "· Австралия",
      uae: "· Объединенные Арабские Эмираты",
      attention: "· ВНИМАНИЕ:",
      attentionText: "PANTA MARKET — это самоуправляемая компания рынка прогнозов WEB3 на основе ИИ. Мы не уполномочиваем третьих лиц взимать плату в любой форме или от любого имени. По вопросам обращайтесь в официальную службу поддержки клиентов по адресу: {email}"
    },
    timeframes: {
      "1s": "1 мин",
      "1m": "1 мин",
      "5m": "5 мин",
      "15m": "15 мин",
      "1h": "1 час",
      "4h": "4 часа",
      "1d": "1 день"
    },
    statusHotEn: "HOT",
    yes: "Да",
    no: "Нет",
    hotBannerTitle: "Событийный контракт",
    homeBanner: {
      s1t1: "На базе ИИ",
      s1t2: "Ядро экосистемы AstralX",
      s1cta: "AstralX",
      s2t: "Фонд Galaxy",
      s2s1: "О защите капитала",
      s2s2: "и правилах выплат",
      s2cta: "Подписаться",
      s3s: "Прогноз цены",
      s3cta: "Прогноз",
    },
    catCrypto: "Крипто",
    catMetal: "Металлы",
    catSports: "Спорт",
    catPolitics: "Политика",
    catEntertainment: "Развлечения",
    statusHot: "Хит",
    statusLocked: "Заблокировано",
    statusLive: "Идёт",
    statusLockedWait: "Заблокировано, ожидание расчёта",
    jouleUnit: "JOULE",
    nowLabel: "Сейчас",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "Ещё {n} вариантов",
    categoryAll: "Все",
    categoryCrypto: "Крипто",
    categoryEquity: "Акции",
    categoryCommodity: "Сырьё",
    categoryForex: "Форекс",
    categoryMetal: "Металлы"
  },
  withdraw: {
    title: "Вывод",
    headerTitle: "Вывод",
    address: "Адрес для вывода",
    addressLabel: "Адрес для вывода",
    addressPlaceholder: "Введите или вставьте адрес",
    network: "Сеть",
    selectNetwork: "Выбрать сеть",
    networkHint: "Убедитесь, что адрес вывода соответствует выбранной сети",
    withdrawAmount: "Сумма вывода",
    receiveAmount: "Сумма к получению",
    networkFee: "Комиссия сети",
    submit: "Подтвердить вывод",
    submitButton: "Вывести",
    balance: "Баланс:",
    all: "Все",
    amountPlaceholder: "Пожалуйста, введите",
    minimumWithdrawal: "Минимальная сумма вывода: {amount} USDT",
    fee: "Комиссия",
    confirm: "Подтвердить",
    confirmTitle: "Подтвердите действие",
    confirmContent: "Вы уверены, что хотите продолжить?",
    toasts: {
      fetchFailed: "Не удалось получить активы",
      enterAddress: "Пожалуйста, введите адрес для вывода",
      enterValidAmount: "Пожалуйста, введите действительную сумму для вывода",
      insufficientBalance: "Недостаточно средств",
      minimumAmount: "Минимальная сумма вывода {amount} USDT",
      processing: "Обработка...",
      success: "Вывод успешен!",
      requestSuccess: "Запрос на вывод успешно отправлен",
      requestFailed: "Ошибка вывода, попробуйте еще раз",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "Депозит",
    connectPrompt: "Пожалуйста, подключите ваш кошелек для пополнения",
    loading: "Загрузка...",
    depositAddress: "Адрес для пополнения",
    minimumDeposit: "*Минимальный депозит 10.0000 USDT",
    depositAmount: "Сумма пополнения",
    balance: "Баланс",
    amaBalance: "Баланс TAKER",
    amount: "Сумма",
    amountPlaceholder: "Введите сумму пополнения",
    minimumNotice: "*Минимум {min} {token}",
    processing: "Обработка...",
    confirm: "Подтвердить депозит",
    confirmTitle: "Подтвердите действие",
    confirmContent: "Вы уверены, что хотите продолжить?",
    helpText: "Депозит вызовет метод recharge смарт-контракта, требуется одобрение токена TAKER",
    toasts: {
      copySuccess: "Успешно скопировано",
      dataLoadFailed: "Не удалось загрузить данные",
      enterValidAmount: "Пожалуйста, введите действительную сумму пополнения",
      invalidAmount: "Сумма депозита не может быть меньше {min} TAKER",
      invalidAddress: "Неверный адрес для пополнения",
      checkingAllowance: "Проверка лимита...",
      approving: "Одобрение...",
      approveSuccess: "Одобрение успешно",
      depositing: "Пополнение...",
      depositSuccess: "Пополнение успешно",
      depositFailed: "Пополнение не удалось",
      balanceLoadFailed: "Не удалось прочитать тестовый баланс USDT. Обновите и повторите",
      contractError: "Вызов контракта не удался, проверьте баланс",
      userCancelled: "Вы отменили операцию",
      insufficientFunds: "Недостаточно средств",
      wrongNetwork: "Пожалуйста, переключитесь на правильную сеть",
      requestingAuth: "Запрос авторизации кошелька...",
      waitingConfirmation: "Ожидание подтверждения транзакции...",
      transactionFailed: "Не удалось инициировать транзакцию",
      transactionCancelled: "Вы отменили транзакцию",
      genericError: "Транзакция не удалась",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "Моя команда",
    contractEarnings: "Мои доходы по контрактам",
    btcFund: "Доход от финансов",
    stats: {
      teamSubscribed: "Стейк команды",
      personalSubscribed: "Личный стейк",
      totalTeam: "Оборот команды",
      periodTeam: "Доход команды",
      periodPersonal: "Личный оборот",
      personalEarnings: "Личный накопленный доход",
      teamEarnings: "Доход команды",
      personalVolume: "Личный оборот",
      teamVolume: "Оборот команды",
      personalPower: "Личная мощность",
      teamTotalPower: "Общая мощность команды"
    },
    links: {
      invite: "Пригласить друзей",
      details: "Детали команды"
    },
    inviteBannerTitle: "Пригласите друзей и откройте комиссии",
    inviteBannerSubtitle: "Разблокируйте командные комиссии",
    inviteBannerCta: "Участвовать",
    unclassifiedHint: "Источник прошлых выплат требует проверки: {amount} {asset}"
  },
  my: {
    headerTitle: "Мой",
    login: "Нажмите, чтобы войти",
    inviteCode: "Код приглашения:",
    groups: {
      common: "Общие функции",
      trading: "Торговля",
      finance: "Финансы",
      help: "Помощь"
    },
    features: {
      invite: "Пригласить друзей",
      team: "Моя команда",
      insurance: "Страхование контрактов на события",
      contract: "Контракт на событие",
      exchange: "Обмен",
      fund: "Казначейский фонд AI",
      communitySquare: "Площадь сообщества",
      createEvent: "Создать событие",
      community: "Официальное сообщество",
      terms: "Условия обслуживания",
      announcement: "Объявления",
      privacy: "Политика конфиденциальности",
      aboutUs: "О нас"
    }
  },
  finance: {
    title: "Страница финансов находится в разработке..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "Обмен не выполнен: условия не соблюдены",
    internalPrice: "Внутренняя цена",
    marketPrice: "Рыночная цена",
    coinBasis: "В монете",
    legacyBasis: "В монете",
    contractBasis: "База расчёта",
    unitPrice: "Цена покупки за единицу",
    quotaUsed: "Покупки по внутренней цене всего",
    quotaRemaining: "Остаток внутренней квоты",
    quotaHint: "Пожизненный лимит {limit} PANTA по всем планам. Отключение, погашение и смена VIP не обнуляют накопленное.",
    principal: "Основная сумма",
    principalReturn: "Возврат основной суммы",
    dailyYield: "Дневной валовой доход",
    coinYieldHint: "Дневной доход = основная сумма PANTA × годовая ставка ÷ 360 с округлением вниз в минимальных единицах. Цена не меняет число монет договора. Распределение — по действующим правилам.",
    legacyHint: "Договор в монете. Возврат основной суммы в PANTA рассчитывается по договорной цене погашения.",
    quotaError: "Внутренняя квота превышена. Уменьшите количество; автоматического разделения и перехода на рыночную цену нет.",
    permissionChanged: "План недоступен вашему VIP. Список обновлён.",
    quoteChanged: "Цена или право доступа изменились. Проверьте новую котировку и подтвердите снова.",
    quoteExpired: "Котировка истекла. Обновите и проверьте её.",
    retryQuote: "Обновить котировку",
    stakeGateTitle: "Стейкинг для продажи PANTA",
    stakeGateBody: "VIP{vip}: активный стейкинг {staked} PANTA; требуется {required} PANTA; не хватает {shortfall} PANTA. Ограничена только продажа, не покупка.",
    goStake: "К стейкингу",
    refreshEligibility: "Обновить допуск",
  },
  fundPage: {
    heroTitle: "Ежедневные выплаты дохода в PANTA",
    heroDesc: "Подпишитесь на фонд Galaxy и получайте годовые дивиденды",
    learnMore: "Подробнее",
    allProducts: "Все продукты",
    subscribe: "Подписка",
    stake: "Стейкинг",
    stakePreview: "Предпросмотр стейкинга",
    searchCoin: "Поиск монеты",
    allPeriods: "Все сроки",
    colCoin: "Название фонда",
    colApy: "Годовая доходность в монете",
    colTerm: "Срок",
    fixedTerm: "Срочный",
    galaxyProduct: "Galaxy {n}",
    termLabel: "Срок",
    apyLabel: "APY",
    stakeCap: "Личные активы",
    stakeAmount: "Сумма стейкинга",
    estEarnings: "Ожидаемый доход",
    stakeDisclaimer: "Доходность иллюстративна и не гарантируется. Около 70% поступает на доступный баланс, 30% — в пробные средства; пробные средства разблокируются после ~3× оборота.",
    stakeSuccess: "Стейкинг успешен",
    annualized: "Ориентир. APY",
    perShareYield: "Доход / 10 тыс. (WBS)",
    dayUnit: "д",
    empty: "Пока нет продуктов фонда",
    loadFailed: "Не удалось загрузить",
    rulesTitle: "О фонде",
    gotIt: "Понятно",
    pantaAvailable: "Доступно PANTA",
    activeFaceValue: "Активные доли",
    totalReward: "Накопленный доход фонда (PANTA)",
    fundYieldUnavailable: "--/Обновите сервис",
    effectiveVip: "Действующий уровень",
    myHoldings: "История покупок фонда",
    faceValue: "Стоимость",
    maturity: "Погашение",
    stakeStart: "Время стейкинга",
    pantaPrice: "Цена PANTA",
    noMoreHoldings: "Больше нет позиций",
    subscriptionStatus: {
      ACTIVE: "Активна",
      SETTLED: "Завершена",
      CANCELLED: "Отменена",
      MANUAL_REVIEW: "Ручная проверка",
    },
    minPanta: "Мин. PANTA",
    pantaAmount: "Сумма подписки (PANTA)",
    stepHint: "Кратно {step}, минимум {min}",
    getQuote: "Получить котировку",
    confirmStake: "Подтвердить стейкинг",
    jouleDebit: "Списание JOULE",
    expectedPanta: "Стейкинг PANTA",
    quoteExpires: "Котировка действует до",
    unavailable: "Пока недоступно",
    invalidAmount: "Введите корректное количество PANTA по шагу",
    quoteFailed: "Ошибка котировки",
    rewards: "Награды фонда",
    unlock: "Партии заморозки PANTA",
    unlockProgress: "Использованный оборот",
    pantaLedger: "Книга PANTA"
  },
  finanfund: {
    title: "Казначейский фонд TAKER",
    subtitle: "Просто, Эффективно, Легкий заработок",
    productName: "Казначейский фонд TAKER",
    minAmount: "Мин. сумма",
    incomeRatio: "Доходность",
    lockPeriod: "Период блокировки",
    dailyReturn: "Дневной доход",
    earning: "Заработано",
    redemptionRules: "Правила погашения",
    rules: {
      rule1: "Казначейский фонд TAKER не может быть погашен после депозита",
      rule2: "Ежедневный доход зачисляется автоматически",
      rule3: "Заблокированная сумма будет возвращена после окончания периода блокировки"
    },
    subscription: "Подписка",
    amountPlaceholder: "Введите сумму",
    balance: "Баланс",
    availableFunds: "Доступные средства",
    all: "Все",
    subscribeButton: "Подписаться",
    toasts: {
      productIdNotExist: "ID продукта не существует",
      enterValidAmount: "Пожалуйста, введите корректную сумму подписки",
      minAmountRequired: "Сумма подписки не может быть меньше {amount} USDT",
      subscribeSuccess: "Подписка успешна",
      subscribeFailed: "Ошибка подписки"
    }
  },
  community: {
    title: "Официальное сообщество",
    bannerTitle1: "Присоединяйтесь к нашему сообществу",
    bannerTitle2: "Общайтесь с пользователями по всему миру",
    linkCopied: "Ссылка скопирована"
  },
  invite: {
    headerTitle: "Пригласить друзей",
    rulesEntry: "Правила приглашения",
    subtitle: "Доход с каждой сделки команды",
    mainTitle: "Приглашай и зарабатывай",
    description: "Поделись ссылкой — друзья торгуют, ты получаешь",
    yourCode: "Ваш код",
    shareLink: "Ссылка для шаринга",
    inviteButton: "Пригласить друзей",
    subTitle: "Получайте высокие комиссионные",
    viewRules: "Посмотреть правила",
    rulesLink: "Посмотреть правила реферальной программы >",
    rulesTitle: "Правила реферальной программы",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Пригласить друзей",
    referralCode: "Реферальный код",
    inviteLink: "Пригласительная ссылка",
    loading: "Загрузка...",
    copyButton: "Копировать пригласительную ссылку",
    toasts: {
      emptyContent: "Содержимое пусто",
      copySuccess: "Успешно скопировано",
      bindSuccess: "Привязка выполнена",
      bindFailed: "Привязка не удалась",
      alreadyBound: "Вышестоящий уже привязан; изменить нельзя",
      loginFirst: "Сначала подключите кошелёк",
      invalidCode: "Введите действительный код приглашения или адрес кошелька",
      cannotBindSelf: "Нельзя привязать самого себя",
    },
    boundLabel: "Вышестоящий привязан",
    modalDesc: "Вышестоящий ещё не привязан. Введите код приглашения или адрес кошелька для командных наград. Данные из ссылки подставляются автоматически; иначе подставляется адрес вышестоящего по умолчанию.",
    bindPlaceholder: "Код приглашения или адрес кошелька",
    bindButton: "Привязать",
    binding: "Привязка…",
    bindSuperior: "Привязать вышестоящего",
  },
  assets: {
    insuranceFrozen: "Замороженный лимит страховки (JOULE)",
    available: "Доступно",
    deposit: "Депозит",
    withdraw: "Вывод",
    myAccountRecords: "Записи моего счета",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "Заморозка ставки",
      WIN_PAYOUT: "Торговая прибыль",
      LOSS_SETTLEMENT: "Торговый убыток",
      REFUND: "Возврат",
      INSURANCE_PREMIUM: "Расход премии",
      INSURANCE_PAYOUT: "Страховая выплата",
      INSURANCE_TRANSFER_IN: "Перевод на страховку",
      INSURANCE_TRANSFER_OUT: "Перевод со страховки",
      NETWORK_DIFFERENTIAL: "Дифференциальная награда",
      NETWORK_PEER: "Награда одного уровня",
      NETWORK_UNLOCK: "Разморозка дохода",
      EVENT_INSURANCE_PAYOUT: "Выплата узла мощности",
      EVENT_INSURANCE_PEER: "Награда узла одного уровня",
      TRANSFER_IN: "Зачисление",
      TRANSFER_OUT: "Списание",
      PREMIUM_LOCK: "Блокировка премии",
      PREMIUM_SETTLE: "Расход премии",
      PREMIUM_REFUND: "Возврат премии",
      WEALTH_SUBSCRIPTION: "Подписка на фонд",
      SUBSCRIPTION_LOCK: "Блокировка стейкинга",
      WEALTH_DAILY_REWARD: "Дневные проценты фонда",
      WEALTH_TEAM_REWARD: "Командная награда фонда",
      MATURITY_RELEASE: "Возврат капитала по сроку",
      WEALTH_UNLOCK: "Разморозка дохода",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "Торговый P&L",
      PREMIUM: "Премия",
      INSURANCE_PAYOUT: "Страховая выплата",
      TEAM_REWARD: "Командная награда",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "Проценты фонда",
      UNLOCK: "Разморозка",
      PRINCIPAL: "Подписка/возврат",
      TRANSFER: "Внутренний перевод"
    },
    amountPendingReview: "Сумма на проверке",
    creditedSplit: "Доступно {available} · Заморожено {frozen}",
    creditedSplitPending: "Разбивка на проверке",
    afterBalance: "После: доступно {available} · заморожено {frozen}",
    unlockHint: "Заморозка → доступно; не новый доход",
    transferFromInsurance: "Страховой счёт",
    transferFromMain: "Основной счёт",
    all: "Все",
    transfer: "Перевод",
    insuranceDeduction: "Вычет страховки",
    insurancePayout: "Выплата страховки",
    noRecords: "Нет записей",

    actions: {
      deposit: "Депозит",
      withdraw: "Вывод",
      exchange: "Обмен",
      transfer: "Перевод"
    },
    loginPrompt: {
      text: "Пожалуйста, сначала подключите ваш кошелек",
      button: "Подключить"
    },
    toasts: {
      connectFailed: "Ошибка подключения, попробуйте еще раз"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Insurance",
    copyAccountShort: "Копир.",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "Счёт копирования (JOULE)",
    copyTotalPnl: "PnL копир.",
    transferSheet: {
      title: "Перевод",
      pairCopy: "Торговый / Копирование",
      pairInsurance: "Торговый / Страховой",
      tradingAccount: "Торговый счёт",
      copyAccount: "Счёт копирования",
      insuranceAccount: "Страховой счёт",
      jouleHint: "Только перевод JOULE",
      submit: "Отправить",
      transferring: "Перевод...",
      success: "Перевод выполнен",
      failed: "Ошибка перевода, повторите",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "Это сумма стейк-принципала и ожидаемого дохода.",
    stakedPrincipalLabel: "Стейк-принципал",
    stakedExpectedYieldLabel: "Ожидаемый доход",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "Невыплаченный доход команды фонда (PANTA)",
    fundTeamPaidPanta: "Выплаченный доход команды фонда (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "Общая стоимость аирдропов: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  wallet: {
    title: "Мой кошелек",
    address: "Адрес кошелька",
    addressCopied: "Адрес скопирован",
    inviteCode: "Код приглашения",
    logout: "Выйти",
    login: "Войти",
    toasts: {
      networkSwitchCancelled: "Пользователь отменил переключение сети",
      networkConfigNotFound: "Конфигурация сети для {chainId} не найдена",
      signatureCancelled: "Пользователь отменил подпись",
      connectionFailed: "Не удалось подключить кошелек",
      accountSwitched: "Аккаунт кошелька переключен, пожалуйста, переподключитесь",
      connectionTimedOut: "Время подключения истекло, пожалуйста, попробуйте снова",
      loginSuccess: "Вход выполнен успешно",
      logoutSuccess: "Выход выполнен",
      switchNetwork: "Пожалуйста, переключитесь на {chainName} в вашем кошельке перед попыткой внести депозит",
      wrongChain: "Сеть не поддерживается, пожалуйста, переключитесь на {chainName}",
      switchingNetwork: "Переключение сети...",
      switchNetworkFailed: "Не удалось переключить сеть, пожалуйста, вручную переключитесь на {chainName} в вашем кошельке"
    }
  },
  market: {
    title: "Рынок",
    banner: {
      title: "Событийный контракт",
      desc: "Раскройте потенциал заработка on-chain"
    },
    tabs: {
      main: "Основные монеты",
      rise: "Лидеры роста"
    },
    types: {
      crypto: "Криптовалюта",
      stocks: "Акции США",
      forex: "Форекс",
      commodities: "Товары",
      favorites: "Избранное"
    },
    headers: {
      pair: "Торговая пара",
      price: "Последняя цена",
      change: "Изменение за день"
    },
    loading: "Загрузка...",
    loadingMore: "Загрузка ещё...",
    noMoreData: "Больше данных нет"
  },
  notice: {
    loginRequired: "Войдите, чтобы просмотреть объявления",
    empty: "Объявлений пока нет",
    unpublished: "Снято с публикации",
    title: "Объявления",
    helpCenter: "Центр помощи",
    noticeDetail: "Подробности объявления",
    viewDetail: "Подробнее",
    pdfViewer: "Просмотр PDF",
    videoPlayer: "Видеоплеер",
    imageViewer: "Просмотр изображения",
    documentViewer: "Просмотр документа",
    clickToViewPdf: "Нажмите, чтобы просмотреть PDF",
    clickToViewDocument: "Нажмите, чтобы просмотреть документ",
    openInBrowser: "Открыть в браузере",
    tryingViewer: "Пробуем способ {current}/{total}",
    pdfLoadFailed: "Не удалось загрузить предпросмотр PDF, скачайте для просмотра",
    downloadPdf: "Скачать PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "Контракт событий",
    nextRound: "Следующий раунд",
    posCurrent: "Текущ.",
    aiThenPrefix: 'AI тогда: ',
    aiUnlinked: 'AI не связан',
    aiNotRecorded: 'Не записано',
    insuranceLabel: "Страховка",
    insuranceNotSelected: 'Не выбрано',
    insuranceInactive: "Не действует",
    insuranceTypeNone: "Не действует",
    insuranceTypeEvent: "Обычная страховка оформлена",
    insuranceTypeEventShort: "Обычная страховка",
    insuranceTypeAi: "Страховка ИИ оформлена",
    insuranceTypeAiShort: "Страховка ИИ",
    insuranceTypeConverted: "Этот ордер переведён на обычную страховку",
    insuranceTypeUnknown: "Статус страховки уточняется",
    inProgress: "В процессе",
    estimatedPnl: "Оценка прибыли",
    settlementConfirming: "Подтверждение результата",
    balanceSyncing: "Синхронизация баланса",
    pendingReview: "На проверке",
    connecting: "Подключение...",
    connectWallet: "Подключить",
    orderDetail: {
      title: "Детали ордера",
      orderId: "ID ордера",
      symbol: "Пара",
      interval: "Интервал",
      direction: "Направление",
      aiDirection: "ИИ тогда",
      openTime: "Открытие",
      settleTime: "Истекает",
      settledAt: "Расчёт",
      openPrice: "Цена открытия",
      closePrice: "Цена закрытия",
      stake: "Сумма",
      premium: "Премия",
      netProfit: "Чистый P&L",
      status: "Статус",
      orderSource: "Источник ордера",
      converted: "Конверсия страховки",
      notRecorded: "Не записано",
      copied: "ID ордера скопирован",
    },
    orderStatus: {
      CREATED: "Создан",
      ACCEPTED: "Принят",
      CLOSED: "Закрыт",
      FUNDS_LOCKED: "Средства заблокированы",
      AWAITING_SETTLEMENT: "Ожидание расчёта",
      PROCESSING: "Обработка",
    },
    insuranceBalanceInsufficient: "Недостаточно средств на страховом счёте",
    mainBalanceInsufficient: "Недостаточно средств на основном счёте",
    insuranceBalanceRequired: "Недостаточно средств на страховом счёте; нельзя включить страховку",
    insuranceRulesUnavailable: "Правила премии не готовы; нельзя включить страховку",
    insuranceMainRequired: "Недостаточно средств на основном счёте; нельзя включить страховку",
    preferenceLoading: "Загрузка настроек страховки",
    preferenceLoadFailed: "Не удалось загрузить настройки страховки; нажмите, чтобы повторить",
    preferenceSaveFailed: "Не удалось сохранить настройки страховки; повторите",
    preferenceSessionEndedSaveFailed: "Раунд завершён, но настройка отключения не сохранена",
    premiumEstimate: "Оценка премии {premium} JOULE (5-10%)",
    premiumShortfallHint: "На страховом счёте не хватает {amount} JOULE",
    premiumEstimateUnavailable: "Пока нельзя оценить премию",
    premiumBoundEstimate: "Оценка премии привязанной стратегии {premium} JOULE",
    insuranceConfirmTitle: "Подтвердить премию",
    insuranceConfirmBody: "Предпросмотр премии {premium} JOULE. Предпросмотр окончательный. Подтвердите для отправки.",
    actions: {
      rise: "Лонг",
      fall: "Шорт",
      buy: "Купить",
      sell: "Продать"
    },
    holdings: {
      current: "Позиции",
      history: "История сделок",
      currentCount: "Открытых позиций: {n}",
      empty: "Нет позиций",
      historyEmpty: "Нет истории"
    },
    position: {
      openPrice: "Цена входа",
      closePrice: "Цена закрытия",
      profitLoss: "П/У",
      countdown: "До расчета",
      calculating: "Расчет...",
      settled: "Рассчитано",
      settling: "Расчёт",
      active: "Активно",
      settledAt: "Рассчитано в"
    },
    modal: {
      amountPlaceholder: "Введите сумму"
    },
    pairSelector: {
      title: "Выберите пару",
      searchPlaceholder: "Поиск монет"
    },
    errors: {
      dataNotReady: "Загрузка данных, пожалуйста подождите"
    },
    marketPause: {
      default: "Рынок временно недоступен. Попробуйте позже.",
      lastPriceStreamWarming: "Лента цен подготавливается. Попробуйте чуть позже.",
      marketWarming: "Рынок подготавливается. Попробуйте чуть позже.",
      recovering: "Рынок восстанавливается. Попробуйте чуть позже.",
      clockNotSynced: "Часы сервера не синхронизированы. Попробуйте чуть позже.",
      symbolUnavailable: "Эта торговая пара пока недоступна"
    },
    toasts: {
      connectSuccess: "Успешно подключено",
      connectCancelled: "Вы отменили подключение",
      connectFailed: "Ошибка подключения"
    },
    openPriceLabel: "Открытие",
    secondsUnit: "s",
    amountLabel: "Сумма",
  },
  exchange: {
    title: "Быстрый обмен",
    from: "Из",
    to: "В",
    balance: "Баланс",
    all: "Все",
    placeholder: "Пожалуйста, введите",
    fee: "Комиссия",
    minAmount: "Минимальная сумма обмена: {amount} {symbol}",
    button: "Обменять",
    tradeButton: "Торговля",
    paymentCurrency: "Валюта платежа",
    estimatedGasFee: "Ориентировочная комиссия за газ",
    gasPaymentNote: "Для оплаты комиссии за газ будет использован баланс GetGas",
    slippage: "Проскальзывание",
    auto: "Авто",
    approximately: "Прибл",
    minReceived: "Минимум получено",
    exchangeRate: "Обменный курс",
    finalAmount: "Итоговая сумма",
    confirm: "Подтвердить",
    swapSuccess: "Быстрый обмен успешен!",
    swapping: "Обмен...",
    confirmTitle: "Подтвердите действие",
    confirmContent: "Вы уверены, что хотите продолжить?",
    toasts: {
      fetchFailed: "Не удалось получить активы",
      enterValidAmount: "Пожалуйста, введите действительную сумму",
      swapSuccess: "Обмен успешен",
      requestFailed: "Ошибка запроса",
      insufficientBalance: "Недостаточно средств, невозможно обменять",
      minAmount: "Minimum swap amount is {amount} {symbol}",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "Комиссия Joule → USDT {fee}",
    configLimits: "Комиссия {fee} · Лимит валовой стоимости {min}–{max} U",
    unlimited: "Без ограничений",
    quoteFailed: "Не удалось получить котировку, попробуйте снова"
  },
  globalNode: {
    title: "Глобальный узел"
  },
  eventInsurance: {
    title: "Страхование контракта события",
    availableBalance: "Доступный баланс (USDT)",
    fundTransfer: "Перевод средств",
    fundHistory: "История средств",
    type: "Тип: ",
    all: "Все",
    transfer: "Перевод",
    fundTransferTitle: "Перевод средств",
    currency: "Валюта",
    from: "От",
    to: "Кому",
    availableAccount: "Доступный счет",
    contractInsuranceAccount: "Страховой счет контракта",
    pleaseEnter: "Пожалуйста, введите",
    confirmTransfer: "Подтвердить перевод",
    insufficientBalance: "Недостаточный баланс",
    transferSuccess: "Перевод выполнен",
    transferFailed: "Ошибка перевода",
    transferring: "Перевод...",
    noRecords: "Нет записей",
    selectAccount: "Выбрать счет",
    cannotTransferToSameAccount: "Невозможно перевести на тот же счет",
    cannotTransferContractAccount: "Перевод на контрактный счет не поддерживается",
    contractAccount: "Контрактный счет (TAKER)",
    rulesTab: "Обзор",
    agreementTab: "Полное соглашение",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. Правила прогноза событийного контракта",
      eventOpen: {
        title: "1. Insurance on",
        points: [
          "With insurance on, premium is based on order size vs account balance: ≤10% of balance → 15% premium; above → 20%.",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      eventLimit: {
        title: "2. Order threshold",
        points: [
          "Max per order is 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Compensation entitlement rules",
        ok: [
          "50% of compensation goes to personal airdrop quota; every 50 USD unlocks one computing node",
          "30% goes to community airdrop quota by VIP rules; every 50 USD unlocks one computing node"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      eventPool: {
        title: "4. Event insurance pool payout:",
        points: [
          "Daily 2% of event insurance pool assets in PANTA is airdropped by node weight to eligible users",
          "When daily pool airdrops reach 50 USD in PANTA, one computing node is reduced"
        ]
      },
      eventProfit: {
        title: "5. P&L rules",
        points: [
          "Correct: receive principal 100% + profit (80%)",
          "Wrong: lose all stake principal; prediction ends"
        ]
      },
      aiGroup: "II. Правила AI-прогноза",
      aiFirst: {
        title: "1. First order requires manual input"
      },
      aiOpen: {
        title: "2. Insurance on",
        points: [
          "With insurance on, pay 5%–10% of the position amount as premium",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      aiLimit: {
        title: "3. Order limits",
        points: [
          "Amounts must follow the position table, and each direction must match the AI signal",
          "If not following the table, it becomes a normal event contract prediction",
          "Eight consecutive losses unlock the stated compensation entitlement",
          "A winning order resets the sequence to step 1"
        ]
      },
      table: {
        level: "Account level",
        order1: "Order 1",
        order2: "Order 2",
        order3: "Order 3",
        order4: "Order 4",
        order5: "Order 5",
        order6: "Order 6",
        order7: "Order 7",
        order8: "Order 8"
      },
      claimOk: "Eligible for compensation",
      claimFail: "Not eligible for compensation",
      claimFailWhen: "When not eligible:",
      claimPrereq: "Compensation prerequisites:",
      aiClaim: {
        title: "4. Compensation entitlement",
        prereq: [
          "Insurance enabled",
          "Direction matches AI signal",
          "Amount/order follows the table",
          "Full settlement conditions met"
        ],
        ok: [
          "Cash compensation = cumulative loss × 90%"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      aiProfit: {
        title: "5. Profit rules",
        points: [
          "Correct: receive principal 100% + profit 80%",
          "Wrong: lose all stake principal; prediction ends or compensation applies"
        ]
      }
    },
    rulesContent: "PANTA Market Договор страхования по плану защиты торговли контрактами на события\n\n【Важное уведомление】Перед использованием данной услуги внимательно прочитайте и полностью поймите всё содержание договора. Система будет считать, что включение пользователем «Страхового переключателя» означает, что вы полностью прочитали, поняли и приняли договор и приложения, подтверждаете его юридическую обязательность и соглашаетесь строго соблюдать его; если вы не согласны и не принимаете условия, немедленно прекратите использование данного плана защиты.\n\nСтатья 1: Общие положения и сфера применения\n\n1.1 Настоящий договор описывает способ участия, формирование ордеров, комиссии, определение результатов, расчёты по средствам, условные выплаты, а также связанные права узлов и функции прогнозирования событий для двух функций «Прогноз контракта на событие» и «AI-прогноз контракта на событие» в PANTA Market. Для каждого продукта применяются отдельные положения; нельзя напрямую переносить тарифы, условия выплат или правила узлов одного продукта на другой.\n1.2 Прогноз контракта на событие — это функция, при которой пользователь делает вывод относительно заранее указанного события и его возможных результатов, использует JOULE для подачи и создания ордера. Итоговый квалифицированный убыток может по утверждённым правилам формировать лимит личного или командного узла сообщества; такой лимит не является мгновенной денежной выплатой. AI-прогноз контракта на событие — это функция, при которой пользователь, опираясь на действительный сигнал направления AI-прогноза, предоставляемый системой, последовательно подтверждает участие по фиксированной сумме и порядку выбранного плана для создания ордеров. Когда 8 ордеров одной квалифицированной последовательности полностью рассчитаны и все являются убытками, а также одновременно выполнены другие явные условия, выплата JOULE рассчитывается как 90% от суммы квалифицированного основного капитала. Сигнал AI не является гарантией результата, а условная выплата не покрывает все расходы.\n1.3 Настоящий договор, версионированные параметры соответствующего продукта, конкретные правила событий и страница подтверждения пользователя совместно составляют полный набор правил. Страница может отображать только уже утверждённые параметры и не может заменять отсутствие ключевых условий формулировкой «ориентироваться на страницу». При противоречии между документами следует прекратить новые затронутые сделки, объяснить, проверить и исправить ситуацию; нельзя впоследствии в одностороннем порядке выбирать менее благоприятное для пользователя толкование для обработки существующих ордеров.\n1.4 Данный проект связан с реальными активами, прогнозированием событий, условными выплатами и страховой терминологией, командными вознаграждениями, обменом и пулами средств и не относится к продуктам, для которых можно пропустить оценку рисков и соответствия. Правовая природа каждой функции, лицензирование, регионы предоставления, квалификация пользователей, AML, защита потребителей и требования к обработке данных должны быть профессионально проверены в соответствии с фактическим объёмом услуг. Положения об освобождении от ответственности не заменяют необходимые лицензии, распределение средств и меры контроля; настоящий текст не предполагает применение законодательства какой-либо конкретной страны и не утверждает, что продукт уже легально разрешён к эксплуатации.\n\nСтатья 2: Термины и состояние средств\n\n2.1 JOULE — единица измерения основного капитала прогноза, страховой премии и AI-выплат в данном продукте; PANTA — единица актива, используемая для распределения прав узлов и других операций; эквивалент USDT — измерительная база для части лимитов и расчёта стоимости. Их нельзя смешивать; внутреннее отображение чисел не означает возможность немедленного обмена на законное платёжное средство по фиксированному курсу и не означает завершения ончейн-перевода активов; данное пояснение не отменяет уже возникшие по закону и договору права на активы или обязательства по выплатам.\n2.2 Основной капитал ордера — сумма JOULE, которую пользователь фактически подтвердил и которую система приняла по данному ордеру, без учёта страховой премии. Страховая премия — расход, рассчитанный по правилам, применимым к данному ордеру. Общая замороженная сумма обычно равна сумме основного капитала и премии; при наличии других расходов они должны быть заранее раскрыты отдельно, нельзя добавлять неподтверждённые сборы при расчёте.\n2.3 Доступный баланс — баланс, который по текущим правилам счёта можно использовать для новых операций. Замороженный баланс — баланс, зарезервированный для принятых ордеров или одобренных операций и временно недоступный для других действий. Ожидаемая прибыль, выплаты на рассмотрении, лимиты узлов и незачисленные распределения не включаются в доступный баланс. При отображении баланса должно быть указано наименование актива; нельзя напрямую суммировать количества разных активов.\n2.4 AI-последовательность — запись операций, последовательно связанных с 1-го ордера по правилам для одного и того же подтверждённого плана. Текущий шаг, результат ордера и доказательства квалификации поддерживаются сервером. Обычное отключение сети или выход из приложения не означает прекращение последовательности; сброс — это прекращение старой последовательности после выполнения условий настоящего договора.\n2.5 Лимит вычислительного узла — учётная единица, эквивалентная USDT, накопленная по правилам на основе итогового квалифицированного убытка для создания узла. Узел — запись права участвовать в последующем распределении прав, а не мгновенные деньги или зачисленный PANTA, и не становится торгуемым, стейкабельным или свободно передаваемым ончейн NFT только по названию.\n2.6 Снимок правил — версия правил, параметры, суммы, ценовое обоснование, условия и связанные доказательства, сохранённые при подтверждении ордера или последовательности. Новая версия не может перезаписать старый снимок. Серверные записи используются для проверки статуса операций, но пользователь может предоставить иные доказательства для повторной проверки; нельзя исключать обоснованные возражения только потому, что записи хранятся платформой.\n\nСтатья 3: Право на использование и подтверждение договора\n\n3.1 Платформа может предоставлять соответствующие функции только пользователям в утверждённых регионах обслуживания, возрастных диапазонах и диапазонах соответствия требованиям. Официальная версия должна чётко указывать требования к верификации личности, доступный ассортимент продуктов и причины ограничений. Нельзя считать пользователя имеющим право участвовать во всех продуктах только потому, что кошелёк подключён, интерфейс виден или на счёте есть баланс.\n3.2 Пользователь должен использовать счёт и активы, которыми он вправе распоряжаться; запрещается выдавать себя за другого, использовать чужой счёт без разрешения, подделывать квалификационные документы, манипулировать сигналами или доказательствами результатов. Если платформе требуется дополнительная проверка, она должна объяснить необходимые документы и цель операции; ограничения на новое участие и исполнение существующих ордеров должны описываться отдельно.\n3.3 Перед размещением ордера пользователь должен иметь возможность просмотреть основной капитал, страховую премию, возможные дополнительные расходы, варианты прогноза, наихудший убыток, условия расчёта, источник определения и путь разрешения споров. Платформа должна предоставлять чёткие шаги подтверждения и не заменять реальное подтверждение пользователя согласием по умолчанию, скрытыми сборами, автоматическим переключением суммы или побуждением к повторным действиям.\n3.4 Сигналы AI, исторические результаты, примеры доходности, размер пула узлов и записи прав других лиц не являются обещанием будущих результатов. Пользователь может потерять основной капитал принятого ордера и связанную страховую премию; права узлов также могут зависеть от баланса пула, эффективного веса, цены и статуса обработки. Пользователь не должен считать конкретный пример своим фиксированным доходом или определённым сроком возврата.\n\nСтатья 4: Правила прогноза контракта на событие\n\n4.1 Перед началом AI-последовательности пользователь должен просмотреть доступные планы, основной капитал позиции, ожидаемую страховую премию, общую потребность в средствах, срок действия сигнала, правило расчёта 60 секунд и условие выплаты 90%. Новая последовательность может начинаться только с 1-го ордера; план нельзя менять в процессе последовательности; пользователь не может пропускать шаги, менять сумму или использовать параллельные незавершённые ордера для формирования новой квалифицированной последовательности. После выбора результата события и ввода основного капитала JOULE платформа рассчитывает страховую премию по утверждённой базе позиции. Текущая схема: если основной капитал не превышает 10% базы позиции, премия составляет 15% от основного капитала; если превышает 10% базы позиции — 20% от основного капитала. Ровно на границе 10% применяется 15%.\n4.2 Сигнал AI должен отображать объект, направление, время, срок действия и идентифицируемый номер сигнала. При размещении ордера пользователь должен подтвердить направление, соответствующее действительному сигналу на тот момент. Если сигнал обновляется во время ожидания или переподключения, требуется повторная проверка; просроченный сигнал нельзя продолжать использовать из клиентского кэша. Использование сигнала AI не означает, что платформа или алгоритм знает будущий результат. Историческая точность, демонстрационные записи и пояснения прогноза не могут служить гарантией результата данного ордера. Платформа не может заменять фактический основной капитал, премию и условия выплат формулировками «гарантированная победа», «стабильная прибыль» или «ошибка без потерь».\n4.3 Каждое событие должно отдельно указывать название, описание фактов, возможные результаты, время открытия и закрытия, часовой пояс, лимиты участия, критерии определения результата, основные и резервные источники доказательств, расчёт прибыли, наихудший убыток, правила отмены или переноса и порядок апелляции. Для неоднозначных событий, при отсутствии критериев определения или если ключевые экономические параметры не утверждены, нельзя открывать реальное размещение ордеров. При принятии ордера платформа должна проверить, что событие всё ещё открыто, серверное время раньше момента закрытия, опции и версия действительны, квалификация и лимиты пользователя соблюдены, баланс достаточен. Определение закрытия не основывается на времени устройства пользователя и не на том, показывает ли клиент обратный отсчёт в момент нажатия.\n4.4 После успешной заморозки основного капитала и премии и принятия ордера платформа возвращает время принятия и согласованный момент расчёта. Этот момент рассчитывается как серверное время принятия плюс 60 секунд, а не от момента открытия страницы, получения сигнала или нажатия кнопки. Сетевая задержка не сокращает и не продлевает уже установленный критерий определения. 60 секунд означают согласованный момент определения результата и не обещают зачисление средств в тот же миг, когда обратный отсчёт клиента достигает нуля. После наступления момента необходимо получить доказательство результата из согласованного источника; при отсутствии доказательства, аномалии источника или конфликте результатов сохраняется статус ожидания расчёта с пояснением, нельзя автоматически записывать убыток.\n4.5 Только при текущей действительной последовательности, когда правила ясно показаны и нет незавершённых ордеров, и пользователь фактически отправил направление, не совпадающее с действительным сигналом, или сумму, не совпадающую с текущим фиксированным шагом, применяется отказ и сброс с прекращением старой последовательности. Должны быть показаны конкретная причина, затронутая последовательность и следующее доступное действие, с сохранением истории. После сброса в следующий раз можно создать новую последовательность с 1-го ордера; нельзя соединять убыточные ордера старой последовательности с ордерами новой для расчёта 8 последовательных проигрышей. Завершённые результаты старой последовательности сохраняются и не получают автоматически выплату 90%; это не ограничивает право пользователя запросить повторную проверку из-за ошибки платформы, неверного сброса или иного спора.\n4.6 Отклонённый нарушающий запрос сам по себе не исполняется и не создаёт новых потерь основного капитала, премии или убыточного узла. Формулировка в исходных материалах о переводе нарушающего убытка в узел ещё не сформировала исполнимое правило; на её основании нельзя создавать фиктивные убытки или компенсации для отклонённых ордеров.\n4.7 Приостановка пользователем начала следующих шагов не означает, что уже сформировалось 8 последовательных проигрышей; незавершённая последовательность не может запросить выплату 90% пропорционально числу убыточных ордеров. Добровольное прекращение последовательности, длительное бездействие и сроки восстановления требуют официального подтверждения правил; нельзя самостоятельно добавлять нераскрытый срок истечения. Обычный выход и отключение сети нельзя трактовать как добровольный отказ. Одна и та же последовательность должна одновременно выполнить следующие четыре условия, чтобы по текущей схеме рассчитать выплату 90% JOULE: для каждого ордера страховой механизм действительно включён и основной капитал с премией фактически заморожены; направление каждого ордера соответствует действительному AI-сигналу на момент принятия; основной капитал и порядок шагов каждого ордера соответствуют подтверждённому плану; все 8 ордеров полностью рассчитаны и все результаты — квалифицированные убытки. Сумма выплаты равна сумме основного капитала участия 8 квалифицированных ордеров, умноженной на 90%, измеряется и выплачивается в JOULE; премия не входит в эту базу 90%. Выплату нельзя напрямую описывать как возврат 90% всех расходов, и она не автоматически конвертируется в USDT, наличные или PANTA. Обмен других активов требует отдельных правил и разрешения.\n4.8 Возникновение права на выплату и успешная оплата — два этапа. При наличии права, но недостатке средств, аномалии учёта или применимых ограничениях сохраняются обязательство и детали ожидающей выплаты, отображается статус обработки или явная причина приостановки, далее действуют по закону и договору; нельзя переписывать трудности оплаты как несоответствие пользователя требованиям.\n4.9 Выплата выполняется один раз по единственной записи данной последовательности. Если оплата успешна, но ответ потерян, последующие запросы и повторы должны возвращать исходный результат без повторной выплаты. При неудачной оплате сохраняется реальный незавершённый статус; нельзя требовать от пользователя создать новую последовательность или повторно разместить ордер для «активации» исходной выплаты. Если для одной последовательности по механизму предварительного подтверждения допускаются разные тарифы по ордерам, для каждого ордера сохраняется снимок и накапливаются фактические расходы; нельзя просто пересчитать все исторические ордера по одному текущему тарифу. Изменение тарифного механизма, влияющего на уже подтверждённую последовательность, должно сначала определить область применения; нельзя ретроактивно увеличивать расходы через новую страницу.\n4.10 Минимальная единица актива, точность, метод округления по ордерам и обработка остатков должны быть определены до выпуска и поддерживаться последовательно. Округление на странице для удобства чтения не должно изменять бухгалтерские детали; точность в расчётных примерах не является уже утверждённой точностью выплат. Комиссии, спред и остатки нельзя скрывать объединённым отображением.\n\nСтатья 5: Системные услуги\n\n5.1 Отключение сети или тайм-аут запроса: пользователь сначала запрашивает исходный ордер, платформа возвращает фактический статус — принят, явно отклонён или всё ещё ожидает подтверждения. При неизвестном исходном результате нельзя побуждать к повторной оплате; только после последующего подтверждения непринятия можно снова подтвердить новый запрос по действующим правилам.\n5.2 Истечение сигнала или котировки: отклонить старый запрос, показать причину и получить содержимое заново. Нельзя молча заменить новым направлением, суммой или расходами, а также автоматически считать истечение AI-нарушением со сбросом. Если старый запрос уже принят, исполнение идёт по его снимку.\n5.3 Аномалия результата или цены: приостановить затронутое определение, оценку или распределение, предоставить статус, область влияния и канал запроса. Отсутствие результата нельзя записывать как неудачный убыток; аномальная оценка не может использоваться для увеличения базы убытка. Смена резервного источника должна соблюдать заранее опубликованный порядок источников и правила аномалий.\n5.4 Расхождение учёта или неизвестный статус внешней транзакции: сначала проверить исходную запись и внешнее подтверждение, не повторять необратимые действия. После подтверждения неудачи — разморозка или повтор по соответствующим правилам; «неизвестно» не означает «возврат выполнен». Завершённые действия пользователя по средствам и незавершённые последующие шаги покупки монет и внесения в пул должны отображаться отдельно.\n5.5 Недостаток средств: остановить новые связанные операции, которые могут увеличить дефицит, сохранить уже возникшие обязательства, сообщить статус ожидания обработки и действовать по утверждённому плану. Нельзя подделывать зачисление, делать доступный баланс отрицательным или покрывать разницу нераскрытыми дополнительными сборами.\n5.6 Ограничения риска: платформа может проводить необходимую проверку или ограничения по официально утверждённым и надлежащим образом раскрытым правилам, но должна различать ограничение новых ордеров, задержку выплат и отмену квалификации. Ограничения не могут автоматически переписывать исторические выигрыши/проигрыши или уже выполненные экономические условия; для исключений нужны факты и основания, а также доступный путь повторной проверки.\n5.7 При обслуживании, прекращении услуги или закрытии продукта должны быть предусмотрены меры для исторических ордеров, выплат, споров и сверяемых записей. Невозможность добавлять новые сделки не означает исчезновение существующего баланса, подлежащих выплат или права на апелляцию. Отключение переключателя новых операций не должно одновременно закрывать все исторические запросы и процедуры исполнения.\n\nСтатья 6: Ограничение ответственности\n\nЗа убытки, вызванные следующими обстоятельствами, сервис не несёт компенсационной ответственности:\n6.1 Несоблюдение стратегии: любые действия, отклоняющиеся от стандартных правил управления позициями данной платформы\n6.2 Экстремальные рыночные условия: убытки из-за паралича биржи, исчерпания ликвидности, манипуляций рынком\n6.3 Системные и операционные риски: убытки из-за неисправности устройства пользователя, ошибок в действиях, кражи аккаунта\n6.4 Политические и compliance-риски: приостановка или запрет торговли из-за изменений законов, нормативных актов или регуляторных распоряжений\n6.5 Риски внутреннего токена: резкое падение или крах рыночной капитализации JOULE, влияющий на его функции маржи и расчётной валюты\n6.6 Мошенничество и злонамеренные действия: участие пользователя в мошенничестве, отмывании денег, манипуляциях рынком или иной незаконной деятельности\n6.7 Форс-мажор: сбой системы данной платформы вследствие форс-мажора\n\nСтатья 7: Раскрытие рисков\n\nПользователь подтверждает, что полностью понимает и принимает следующие риски:\n7.1 Без гарантии основного капитала и прибыли: данный план компенсирует только часть убытков и абсолютно не гарантирует сохранность основного капитала или прибыль\n7.2 Риск зависимости от стратегии: эффект защиты полностью зависит от строгого соблюдения стратегии\n7.3 Риск ликвидности и блокировки: компенсационные средства, поступающие на счёт управления активами, могут включать инвестиционные риски и период блокировки, влияя на ликвидность\n7.4 Риск третьих сторон: риски работы, безопасности и колебаний стоимости используемых бирж\n7.5 Риск регуляторной неопределённости: данная платформа сталкивается с глобальной регуляторной неопределённостью и риском приостановки\n7.6 Технологические риски безопасности: включая риск потери активов из-за уязвимостей smart contract, хакерских атак и т.п.\n\nСтатья 8: Изменение, прекращение договора и споры\n\n8.1 Изменение договора: платформа оставляет за собой право пересматривать настоящий договор в соответствии с законодательством или операционными потребностями; существенные изменения будут сообщаться через объявления платформы\n8.2 Прекращение договора: пользователь может в любое время отключить переключатель защиты и прекратить услугу; при нарушении договора пользователем платформа может в одностороннем порядке прекратить его; по юридическим или политическим причинам данный план может быть прекращён\n8.3 Разрешение споров: споры, возникающие из настоящего договора, следует решать путём дружественных переговоров; при неуспехе переговоров они передаются в назначенный арbitражный орган или суд\n\n【Окончательное подтверждение】Вы понимаете и соглашаетесь, что «Включение страхового переключателя» является единственным и окончательным способом подтвердить, что вы связаны всем содержанием настоящего договора; пожалуйста, принимайте решение на основе независимого суждения.",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "Подключить",
    inputPlaceholder: "Введите адрес",
    bind: "Привязать",
    binding: "Привязка",
    tip: "Совет: Если подключение кошелька не удалось, вы можете попробовать вручную ввести адрес кошелька для привязки"
  },
  loginModal: {
    title: "Вход в PANTA MARKET",
    connectWallet: "Подключить",
    connecting: "Подключение...",
    alreadyConnected: "Подключено",
    tip: "Совет: Если подключение кошелька не удалось, вы можете попробовать вручную ввести адрес кошелька для привязки",
    inputLabel: "Введите адрес кошелька",
    inputPlaceholder: "0x234d456f6798...",
    bind: "Привязать",
    binding: "Привязка",
    bindSuccess: "Привязка успешна",
    bindSuccessHint: "Привязка успешна, пожалуйста, войдите снова",
    bindFailed: "Привязка не удалась",
    noAuthCode: "Отсутствует код авторизации",
    invalidAddress: "Неверный формат адреса кошелька",
    confirmTitle: "Подтвердить привязку",
    confirmWarning: "Пожалуйста, внимательно подтвердите, что следующий адрес является адресом вашего кошелька. Его нельзя изменить после привязки",
    addressLabel: "Адрес кошелька",
    cancel: "Отмена",
    confirm: "Подтвердить привязку",
    loginSuccess: "Вход выполнен",
    openWalletApp: "Открыть {wallet}",
    openWalletConnect: "Открыть {wallet} для подключения",
    openWalletSign: "Открыть {wallet} для подписи",
    returnToBrowser: "Вернитесь сюда после завершения",
    loginStepLabel: "Шаг {step}/2",
    stepConnectTitle: "Подключить кошелёк",
    stepConnectHint: "Подтвердите подключение в кошельке и вернитесь сюда",
    stepConnectHintWithOpen: "Нажмите ниже, чтобы открыть кошелёк, подтвердите подключение и вернитесь",
    stepSignTitle: "Вход",
    stepSignHint: "Подпишите сообщение входа в кошельке (средства не списываются) и вернитесь сюда",
    stepSignHintWithOpen: "Ещё один шаг: нажмите ниже, чтобы открыть кошелёк и подписать сообщение",
    waitingWalletHintShort: "Если не открылось, нажмите ниже, чтобы открыть кошелёк",
    retryLogin: "Повторить вход",
    networkRequired: "Сменить сеть",
    networkRequiredHint: "Переключитесь на {chain}, вернитесь сюда и повторите попытку",
    switchingNetwork: "Подтвердите смену сети",
    switchingNetworkHint: "Подтвердите переключение на {chain} в кошельке",
    signatureRequired: "Подпишите для входа",
    signatureHint: "Подпишите в кошельке — средства не переводятся",
    verifyingLogin: "Проверка",
    verifyingHint: "Подождите немного",
    connectFailed: "Подключение не завершено, попробуйте снова",

    waitingWalletReturn: "Подтвердите в приложении кошелька и вернитесь сюда",
    waitingWalletHint: "Подтвердите в кошельке — после этого вернётесь сюда"
  },
  walletProfile: {
    title: "Профиль",
    address: "Адрес",
    accountName: "Имя аккаунта",
    inviteCode: "Код приглашения",
    deactivateAccount: "Деактивировать аккаунт",
    logout: "Выйти",
    switchAccount: "Сменить аккаунт",
    confirmLogout: "Вы уверены, что хотите выйти?",
    loggingOut: "Выход...",
    confirmSwitch: "Вы уверены, что хотите сменить аккаунт? Текущий аккаунт будет отключен",
    developing: "В разработке",
    addressCopied: "Адрес скопирован",
    inviteCodeCopied: "Код приглашения скопирован"
  },
  aiPrediction: {
    stakeAutofill: "AI-помощник",
    stakeAutofillWarning: "Только подсказка: сумма может быть неверной — проверьте перед ордером. Автозаполнение паузится при задержке >800 мс или сбое/истечении проверки связи и возобновляется после восстановления. Ручные ордера не затрагиваются.",
    stakeAutofillUnavailable: "Связь нестабильна или задержка >800 мс. Пока нельзя включить.",
    stakeAutofillPaused: "Автозаполнение на паузе: связь нестабильна. Введите сумму вручную.",
    insuranceSyncing: "Синхронизация шага страхования…",
    predictionBuffer: 'Подготовка следующего прогноза',
    scheduleResultPending: 'Результат недоступен, повторная проверка',
    title: "AI Прогноз",
    bookingTitle: "Бронирование сессий AI",
    bookingExpand: "Развернуть",
    bookingCollapse: "Свернуть",
    bookingNextSystem: "Следующая сессия · SGT",
    bookingNextMine: "Моя следующая бронь",
    bookingNone: "Нет",
    bookingStartingSoon: "Забронированная сессия скоро начнётся",
    bookingToday: "Сегодня",
    bookingTomorrow: "Завтра",
    bookingTimezone: "SGT",
    bookingQuota: "Осталось сессий: {remaining}/{dailyLimit}",
    bookingSeats: "{occupied}/{capacity} мест",
    bookingEmpty: "Нет доступных сессий",
    bookingWaiting: "Автовход после завершения текущей операции",
    bookingEnded: "Завершено",
    bookingJoin: "Войти в сессию",
    bookingReserve: "Забронировать",
    bookingJoined: "Вошли",
    bookingReserved: "Забронировано",
    bookingFull: "Мест нет",
    bookingConfirm: "Подтвердить бронь",
    bookingWarning: "Успешная бронь списывает 1 сессию за день, даже если вы не пришли.",
    bookingQuotaExhausted: "Дневной лимит сессий исчерпан",
    bookingUnavailable: "Сейчас нельзя забронировать",
    bookingFailed: "Не удалось забронировать. Обновите и попробуйте снова.",
    aiPool: "Пул ИИ",
    countdown: "Обратный отсчёт",
    expectedProfit: "Ожидаемая прибыль",
    active: "Активно",
    aiAnalysis: "AI Анализ вероятности роста/падения",
    updateTime: "Время обновления",
    probabilityUp: "Вероятность роста",
    probabilityDown: "Вероятность падения",
    startPrediction: "Начать прогноз",
    predicting: "Прогнозирование...",
    stayOnPageHint: "Не покидайте эту страницу, иначе результат прогноза может быть потерян.",
    userInfo: "Информация о пользователе",
    predictCount: "Количество прогнозов",
    freeCount: "Бесплатные прогнозы",
    openTime: "Открыто в: {time1}",
    up: "Рост",
    down: "Падение",
    notConnected: "Не подключено",
    count: "Количество",
    learnMore: "Узнать больше",
    calculating: "Расчёт...",
    settled: "Рассчитано",
    loginFirst: "Сначала войдите в систему",
    sessionSyncing: "Синхронизация",
    actions: {
      rise: "Лонг",
      fall: "Шорт"
    },
    holdings: {
      current: "Позиции",
      history: "История",
      empty: "Нет позиций",
      historyEmpty: "Нет истории",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "Купить привилегию",
      description: "Купить 30 AI прогнозов",
      upgradeAmount: "Сумма апгрейда",
      balance: "Доступный баланс",
      cancel: "Cancel",
      confirm: "Подтвердить",
      purchasing: "Покупка...",
      purchaseSuccess: "Покупка успешна",
      purchaseFailed: "Покупка не удалась",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "Ошибка AI прогноза",
      description: "Количество AI прогнозов равно 0. Вы не можете использовать AI прогноз в данный момент. Пожалуйста, купите, чтобы продолжить.",
      cancel: "Отмена",
      confirm: "Купить AI прогноз"
    },
    toasts: {
      predictionFailed: "Прогноз не удался",
      predictionSuccess: "Прогноз завершён",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "Анализ...",
    insurance: "Страхование",
    insuranceOn: "Активно",
    insuranceOff: "Неактивно",
    aiLabel: "AI",
    lookLong: "Рост",
    lookShort: "Падение",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "Следовать раунду",
    scheduleBinding: "Привязка сигнала...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "Цена открытия",
    settledAt: "Расчёт в",
    ordinaryInsuranceTitle: "Этот ордер — обычная страховка",
    ordinaryInsuranceBody: "Это обычная страховка, а не выплата раунда ИИ. Премия берётся из предпросмотра после подтверждения.",
    sessionConflict: "Раунд страховки ИИ ещё активен. Восстановите или завершите его перед обычной страховкой.",
    conversionTitle: "Перейти на обычную страховку?",
    conversionDesc: "Этот ордер перейдёт на обычную страховку и завершит текущий раунд AI-страховки. Предыдущие серии убытков AI не выплачиваются. Обычная премия {premium} JOULE.",
    conversionConfirm: "Подтвердить переход и ордер",
    stakeFromStrategy: "Размер задаёт стратегия",
    stakeTier: "Уровень {tier}",
    stakeStep: "Шаг {step}",
    selfQuotaRemaining: "Остаток автопрогнозов: {remaining}/{limit}",
    followRoundProgress: "С ИИ · Раунд {current}/{total}",
    followRoundsCompleted: "Сессия ИИ завершена · {current}/{total}",
    selfQuotaLoadingShort: "Загрузка квоты…",
    selfQuotaLoginHint: "Войдите, чтобы увидеть квоту",
    selfQuotaLoading: "Квота загружается, попробуйте позже",
    selfQuotaExhausted: "Бесплатная квота автопрогноза на сегодня исчерпана; платный прогноз ещё не открыт"
  },
  positionModal: {
    title: "Прогноз цены",
    insurance: "Страхование",
    long: "Лонг",
    short: "Шорт",
    balance: "Баланс",
    loading: "Загрузка...",
    confirm: "Подтвердить",
    processing: "Обработка заказа...",
    success: "Заказ успешно размещён!",
    insuranceOn: "Страхование включено",
    insuranceOff: "Страхование отключено",
    operationFailed: "Операция не удалась",
    balanceFetchFailed: "Не удалось получить баланс",
    minAmount: "Минимальная сумма 0.1 TAKER",
    insufficientBalance: "Недостаточно средств, текущий баланс: {balance} TAKER",
    createFailed: "Не удалось создать позицию",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  appeal: {
    title: "Помощь в восстановлении активов",
    records: "Записи отправки",
    recordsTitle: "Записи отправки",
    noRecords: "Нет записей отправки",
    submitTime: "Время отправки",
    statusPending: "В обработке",
    statusApproved: "Одобрено",
    statusRejected: "Отклонено",
    failedReason: "Причина отказа",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "Загрузка...",
    walletAddress: "Адрес, привязанный к PANTA MARKET",
    address: "Адрес",
    walletAddressPlaceholder: "Введите адрес входа в PANTA MARKET",
    autoFill: "Автозаполнение",
    depositAmount: "Сумма депозита",
    depositAmountPlaceholder: "Введите сумму депозита",
    tokenType: "Тип токена",
    selectToken: "Выберите токен",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "Время перевода",
    selectTime: "Выберите время перевода",
    timeRangeHint: "Соответствующие данные, сгенерированные с 5 марта 2026 г. 00:00 по 11 марта 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "Введите хэш транзакции",
    txHashHint: "Можно проверить в обозревателе блокчейна",
    uploadImages: "Скриншот записи перевода",
    uploadHint: "Необязательно, загрузите до 9 изображений",
    addImage: "Добавить изображение",
    submit: "Отправить",
    submitting: "Отправка...",
    submitSuccess: "Успешно отправлено",
    submitFailed: "Не удалось отправить, попробуйте еще раз",
    uploadingImages: "Загрузка изображений...",
    uploadImagesFailed: "Не удалось загрузить изображения",
    warningTitle: "Важное уведомление",
    warningText: "Если отправленная запись успешно проверена, вы получите вознаграждение в размере 5% мощности подписки. Если предоставлена ложная информация, учетная запись будет заморожена."
  },
  withdrawSheet: {
    title: "Вывод",
    balance: "Баланс",
    processing: "Вывод TAKER...",
    success: "Вывод TAKER успешен!",
    withdrawing: " вывод...",
    withdrawSuccess: " Отправлено на проверку",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "Депозит TAKER",
    depositTo: "Депозит в",
    spotAccount: "Спотовый счет",
    network: "Сеть",
    networkWarning: "Поддерживаются только депозиты через сеть BSC/BEP20. Потери активов из-за использования других сетей не могут быть восстановлены.",
    depositAddress: "Адрес депозита",
    address: "Адрес",
    depositTAKER: "Депозит TAKER",
    recharge: "Пополнить",
    rechargeAddress: "Адрес пополнения",
    copy: "Копировать",
    copySuccess: "Скопировано успешно",
    loadingAddress: "Получение адреса пополнения...",
    loadAddressFailed: "Не удалось получить адрес пополнения",
    clickToRetry: "Нажмите, чтобы повторить",
    generating: "Генерация...",
    saveAndShare: "Сохранить и поделиться адресом",
    generateSuccess: "Успешно создано",
    generateFailed: "Не удалось создать",
    more: "Ещё",
    save: "Сохранить",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "Сохраненное изображение",
    download: "Скачать",
    pleaseGenerate: "Пожалуйста, сначала создайте изображение",
    downloadSuccess: "Загрузка успешна",
    saveSuccess: "Сохранено успешно",
    saveFailed: "Не удалось сохранить",
    needPermission: "Требуется разрешение для сохранения изображения в альбом",
    pleaseUseDapp: "Пожалуйста, используйте кошелек для открытия операции dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "Войти в аккаунт",
    inviteBanner: "Приглашайте друзей и зарабатывайте командные комиссии",
    inviteCode: "Код приглашения",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "Мои рефералы",
    currentLevel: "Текущий уровень: {level}",
    nextLevel: "Следующий уровень",
    totalMembers: "Прямые рефералы",
    validMembers: "Действительные члены",
    teamLevel: "Уровень команды: {level}",
    tradeTeam: "Торговая команда",
    financeTeam: "Финансовая команда",
    teamMembers: "Члены команды",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "Прямые {name}",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "Общая прибыль",
    totalFlow: "Общий поток",
    totalInvites: "Всего приглашений",
    validMembers: "Всего действительных членов"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "Новый чат",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "Привет, я ваш AI-ассистент",
    hint: "Спросите про рынок, где смотреть правила страховки события/AI, команду и приглашение, или риск.",
    placeholder: "Спросите что-нибудь...",
    send: "Отправить",
    thinking: "Анализ...",
    disclaimer: "Только для справки — не инвестиционная рекомендация.",
    bullish: "Рост",
    bearish: "Падение",
    aiAnalysis: "AI-сводка",
    strategy: "Стратегия",
    reasoning: "Обоснование",
    targetPrice: "Цель {price}",
    stopLoss: "Стоп {price}",
    takeProfit: "Тейк {price}",
    dirLong: "Лонг",
    dirShort: "Шорт",
    dirNeutral: "Нейтрально",
    analysisDone: "Готов анализ {symbol} ({timeframe}). См. карточку ниже.",
    analysisBtc: "Краткосрочный анализ BTC.",
    analysisEth: "Диапазонный анализ ETH.",
    analysisRisk: "Разбор рыночного риска.",
    suggestions: {
      btc1m: "Анализ краткосрочного BTCUSDT 1m",
      ethTrend: "Гнаться за ETH или ждать?",
      marketRisk: "Каков сейчас аппетит к риску?",
      eventRules: "Где смотреть обзор правил страховки события?",
      aiRules: "Как понять правила/уровни AI-прогноза?",
      teamWhere: "Где смотреть детали команды?",
      inviteWhere: "Где ссылка приглашения / привязка вышестоящего?"
    },
    guides: {
      eventRules: "Правила страховки события: откройте Event Contract и вход правил у переключателя. Обзор — премия/лимиты/выплаты; Полный договор — юридический текст.",
      aiRules: "AI Prediction: центральная вкладка → AI Prediction. Смотрите countdown следующего раунда, уровень/шаг страховки и квоту самопрогноза. Правила в том же листе. Ордер должен совпадать с размером уровня и направлением.",
      teamWhere: "Детали команды: сайдбар или Я → Моя команда. Переключите доход trade/finance, откройте Детали команды: прямые, оборот, уровень, участники.",
      inviteWhere: "Приглашение и привязка: сайдбар/Я → Пригласить друзей, скопируйте ссылку (?ref=). Без вышестоящего после входа появится модал. Без invite-параметра поле предзаполняется адресом по умолчанию системы."
    },
    generic: {
      a: "Понял. Спросите про рынок, где правила события/AI, команда и приглашение — или быстрые подсказки ниже.",
      b: "Ок. Карточки прогноза и навигация по функциям.",
      c: "Попробуйте подсказки: правила события, AI, детали команды, ссылка приглашения."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "Недавние сделки",
    tabLp: "LP",
    tabPositions: "Позиции",
    tabRules: "Правила",
    colAddress: "Адрес",
    colTime: "Время",
    colType: "Тип",
    colVolumePrice: "Объём/цена",
    colTurnover: "Оборот",
    typeBuy: "Покупка",
    typeSell: "Продажа",
    empty: "Нет данных",
    share: "Поделиться",
    rulesBody: "Это бинарный прогноз события. Стакан может быть заблокирован до расчёта; после публикации результата расчёт по доле. Учитывайте риски.",
    priceJoule: "Цена (JOULE)",
    investJoule: "Вложение (JOULE)",
    totalLiquidity: "Ликвидность",
    dealPrice: "Цена исполнения",
    estProfit: "Ожид. прибыль",
    jouleBalance: "Баланс JOULE: {n}",
    positionCount: "Позиции: {n}",
    max: "Макс",
    confirmOrder: "Подтвердить",
    ordering: "Отправка...",
    enterAmount: "Введите сумму",
    invalidPrice: "Неверная цена",
    amountExceed: "Превышен баланс",
    orderSuccess: "Ордер создан",
    poolSize: "Размер пула",
    colBalance: "Баланс",
    shares: "{n} ед.",
    rulesTitle: "Правила",
    rulesValue: "Нет описания",
    settleSource: "Источник расчёта",
    settleValue: "Нет описания"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "Токен управления PANTA",
    todayBurn: "Сожжено сегодня",
    totalBurn: "Всего сожжено",
    burned: "Сожжено",
    initialSupply: "Начальный выпуск",
    maxSupply: "Макс. выпуск",
    finalCirculation: "Итоговое обращение",
    contractAddress: "Контракт: ",
    copied: "Скопировано",
    ecoSection: "PANTA · AI-экосистема",
    ecoTabs: {
      market: "Анализ рынка",
      arbitrage: "Арбитраж",
      acquisition: "Глобальный охват",
      video: "Видеоконтент"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · Креативные группы",
    groupTabs: {
      recommend: "Для вас",
      hot: "Популярное",
      ipDrama: "IP-драма",
      ipCollab: "IP-сотворчество",
      data: "Данные"
    },
    filters: {
      all: "Все",
      new: "Новинки",
      ending: "Скоро конец",
      highScore: "Высокий AI-балл"
    },
    project: {
      badge: "Премьера на Planet",
      title: "《Panta AI · Восхождение》 Короткометражный AI-мультфильм",
      score: "AI-балл 92",
      tagDrama: "IP-драма",
      tagRights: "Права #0001",
      desc: "Panta AI помогает переломить ситуацию — обучающий AI-сериал"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4 212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "Копитрейдинг",
    pageTitle: "Копитрейдинг",
    fallback: "Операция не удалась. Повторите попытку позже.",
    pauseRule: "Если на момент завершения расчёта этой недели копирование всё ещё приостановлено, отношение копирования будет автоматически отменено на следующей неделе.",
    pauseSuccess: "Приостановлено",
    resumeSuccess: "Возобновлено",
    endSuccess: "Завершено",
    followSuccess: "Копирование начато",
    pendingReviewToast: "Ожидает проверки трейдера",
    savedSuccess: "Сохранено",
    registerSuccess: "Регистрация выполнена. Депозит заморожен.",
    cancelRequested: "Запрошена отмена",
    cancelWithdrawn: "Отмена отозвана",
    kickedSuccess: "Удалён",
    approvedSuccess: "Одобрено",
    rejectedSuccess: "Отклонено",
    filledToForm: "Заполнено в форму подписки",
    traderNotFound: {
      search: "Трейдер не найден. Проверьте адрес кошелька или возможно он ещё не включил копитрейдинг.",
      business: "Этот трейдер сейчас недоступен"
    },
    tabs: {
      board: "Рейтинг",
      follows: "Мои подписки",
      join: "Подписаться",
      trader: "Лидировать",
      apps: "Заявки",
      fans: "Подписчики",
      rules: "Правила",
      settings: "Правила",
      follow: "Подписаться"
    },
    ui: {
      refresh: "Обновить",
      search: "Поиск",
      loginWallet: "Подключить кошелёк",
      needLoginAction: "Для этого действия нужен вход через кошелёк, как при размещении ордеров.",
      needLoginTrader: "API трейдера требуют входа.",
      loginToView: "Войдите для просмотра",
      loading: "Загрузка…",
      empty: "Нет",
      readonly: "только чтение",
      yes: "Да",
      no: "Нет",
      immediate: "немедленно",
      current: "Текущий",
      nextWeek: "Следующая неделя",
      pause: "Пауза",
      resume: "Возобновить",
      end: "Завершить",
      save: "Сохранить",
      kick: "Удалить",
      approve: "Одобрить",
      reject: "Отклонить",
      requestCancel: "Запросить отмену",
      withdrawCancel: "Отозвать отмену",
      confirmFollow: "Подтвердить подписку",
      registerWithDeposit: "Заморозить депозит и зарегистрироваться",
      registerConfirmTitle: "Подтвердить регистрацию",
      registerFreezeConfirm: "На торговом счёте будет заморожено {amount} JOULE залога.",
      platformSettings: "Настройки платформы",
      settingsTip: "Копируются только обычные застрахованные ордера лидера. Незастрахованные обычные и AI-ордера не копируются, а сгенерированные COPY-ордера не запускают дальнейшее копирование. Трейдеры используют существующий API ордеров и не должны передавать orderSource. Подписчики видят COPY-ордера в списке. Суммы показываются с 2 знаками; лишние отбрасываются.",
      deposit: "Депозит",
      depositFreezeWeeks: "Недели заморозки депозита",
      maxFollowers: "Лимит подписчиков",
      shareRateRange: "Диапазон доли прибыли",
      shareRateDefault: "Доля прибыли по умолчанию",
      shareRateNextWeek: "Доля прибыли действует со следующей недели",
      pendingShareHint: "Со следующего понедельника: {rate}",
      pendingMaxFollowersHint: "Со следующего понедельника: {n}",
      depositFrozenShort: "Ещё заморожено",
      minFollowStake: "Мин. сумма подписки",
      ratioRange: "Диапазон коэффициента",
      maxSimultaneousFollows: "Макс. одновременных подписок",
      defaultReview: "Проверка по умолчанию",
      defaultMinBalance: "Порог баланса по умолчанию",
      settlementTimezone: "Часовой пояс расчёта",
      leaderboardMeta: "Мин. рейтинга / размер",
      leaderboardMetaValue: "{min} ордеров / {size} строк",
      weekLeaderboard: "Рейтинг винрейта этой недели",
      expertLeaderboard: "Рейтинг трейдеров",
      heroTitle: "Станьте лид-трейдером",
      heroDesc: "Начните вести сделки и получайте долю прибыли",
      heroActiveTitle: "Вы лид-трейдер",
      heroActiveDesc: "Ваш статус лид-трейдера активен",
      heroRegister: "Регистрация",
      heroSettings: "Настройки лидерства",
      myLeading: "Моё лидерство",
      winRateBoard: "Винрейт",
      pnlBoard: "Прибыль",
      searchAddress: "Поиск адреса",
      searchNicknameOrAddress: "Поиск по нику или адресу",
      searchQueryTooShort: "Введите не менее 2 символов",
      winRateShort: "Винрейт",
      followersLabel: "Подписчики:",
      shareRateLabel: "Доля прибыли:",
      roundPnlLabel: "PnL раунда:",
      settledOrders: "Расчёт {n}",
      activeCount: "В процессе",
      followStatsShort: "Пул {pool} · Удержано {cash}",
      traderSettings: "Настройки лидерства",
      confirmChanges: "Подтвердить изменения",
      confirmCancel: "Подтвердить отмену",
      cancelModalTitle: "Уведомление об отмене",
      activeInProgress: "В процессе",
      leadingFollowerCount: "Подписчики {n}",
      auditApps: "Заявки {n}",
      leaderboardNote: "Учитываются только выигранные/проигранные застрахованные обычные ордера этой недели после минимального числа ордеров. Не общий винрейт и не AI-винрейт. Название команды и накопленный объём подписок не предоставляются.",
      weekStart: "Начало недели (пн.): {date}",
      leaderboardEmpty: "В рейтинге пока нет трейдеров. Найдите по полному адресу для подписки.",
      winRate: "Винрейт {n}%",
      boardSub: "Доля {share} · Подписчики {followers}/{max} · Расчёт {orders} · Нед. PnL {pnl} JOULE",
      searchTrader: "Поиск трейдера",
      walletPlaceholder: "Полный адрес кошелька 0x…",
      address: "Адрес",
      status: "Статус",
      shareRate: "Доля прибыли",
      review: "Проверка",
      minBalance: "Порог баланса",
      followerCount: "Подписчики",
      startFollow: "Начать подписку",
      traderWallet: "Адрес трейдера",
      followMode: "Режим подписки",
      ratioLabel: "Коэффициент (%), диапазон {min} ~ {max}",
      insuranceMode: "Режим страховки",
      takeProfit: "Тейк-профит (JOULE, необяз.)",
      stopLoss: "Стоп-лосс (JOULE, необяз.)",
      takeProfitPh: "Пауза при достижении недельного чистого PnL",
      stopLossPh: "Пауза при достижении недельного чистого убытка",
      followHint: "Одновременно можно подписаться максимум на {n} трейдера(ов). При лимите новая подписка сначала завершит текущую — это не безопасный предпросмотр. Для смены параметров завершите и подпишитесь снова.",
      endConfirm:
        "Завершить отношение копирования с этим трейдером? После этого сигналы больше не будут копироваться. Исторические ордера и рассчитанный PnL не затрагиваются.",
      weeklyPoolHint: "Пул относится к этой неделе, а не к накопленному объёму подписок. Завершённые отношения и ожидающие заявки не в этом списке.",
      networkUnclear: "Результат не подтверждён. Обновите и проверьте текущее отношение или профиль трейдера перед повтором.",
      myFollows: "Мои подписки",
      noFollows: "Нет отношений подписки",
      followSub: "{mode}{ratio} · {insurance} · Заблок. доля {share}",
      followStats: "Нед. PnL {pnl} · Пул {pool} · Удержано {cash}",
      pauseReason: "Причина паузы: {reason}",
      registerTrader: "Зарегистрироваться как трейдер",
      registerHint: "Регистрация: внесите {amount} JOULE как депозит лид-трейдера (заморожен при активности; возврат после проверки отмены). Один трейдер на кошелёк.",
      registerBalanceHint: "После заморозки депозита {deposit} JOULE доступный баланс должен оставаться ≥ {remain} JOULE.",
      shareRateInput: "Доля прибыли (%) диапазон {min} ~ {max}; изменения со следующего цикла.",
      maxFollowersInput: "Лимит подписчиков (≤ {max})",
      reviewMode: "Способ одобрения",
      minBalanceInput: "Порог баланса подписчика · необяз. (JOULE)",
      myTrader: "Мой профиль трейдера",
      depositHeld: "{amount} / заморожено {held}",
      currentFollowers: "Текущие подписчики",
      cancelEffective: "Отмена вступает в силу",
      depositRelease: "Возврат депозита",
      editParams: "Изменить настройки",
      editHint: "Доля / лимит — со следующей недели; проверка и порог — сразу. Блокировка расчёта: вс 22:00 до пн 01:00 (SGT). Ориентируйтесь на сервер; не возобновляйте правки в пн 00:00 самостоятельно.",
      shareRatePercent: "Доля прибыли (%)",
      minBalanceJoule: "Порог баланса (JOULE)",
      cancelTip: "После отмены вы всё ещё лидируете эту неделю; статус заканчивается в следующий понедельник 00:00; депозит заморожен ещё неделю, затем возвращается. Можно отозвать до вступления в силу.",
      followers: "Подписчики",
      followerSub: "{mode}{ratio} · Нед. PnL {pnl} · Удержано {cash}",
      applications: "Ожидающие заявки",
      noApplications: "Нет заявок",
      fillForm: "Заполнить форму подписки",
      needTraderFirst: "Сначала зарегистрируйтесь как трейдер",
      cancelRequestedAt: "Отмена запрошена",
      ratioRangeInvalid: "Коэффициент должен быть между {min} и {max}",
      shareRangeInvalid: "Доля прибыли должна быть между {min} и {max}",
      maxFollowersInvalid: "Лимит подписчиков не может превышать {max}",
      needShareRate: "Введите долю прибыли",
      needMaxFollowers: "Введите лимит подписчиков",
      needRatio: "Введите коэффициент",
      badTakeProfit: "Неверная сумма тейк-профита",
      badStopLoss: "Неверная сумма стоп-лосса",
      badMinBalance: "Неверный порог баланса",
      insuranceShortFollow: "Следовать",
      insuranceShortOn: "Всегда вкл.",
      insuranceShortOff: "Всегда выкл.",
      symbolSettings: "Настройки символов копирования",
      symbolPickHint: "по умолчанию всё выкл.; включайте вручную, можно менять в любое время",
      followSymbolHint: "Выберите из символов, разрешённых этим трейдером. Включите хотя бы один.",
      followSymbolWait: "Сначала найдите трейдера, затем выберите символы для подписки.",
      symbolNeedOne: "Включите хотя бы один символ",
      symbolNotAllowed: "Выбранный символ не разрешён этим трейдером",
      effectiveSymbols: "Активные",
      editSymbols: "Изменить символы",
      allowedSymbols: "Открытые символы",
      weekPnlLabel: "PnL недели:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "Крипто",
      categoryCommodity: "Сырьё",
      categoryEquity: "Акции",
      symbolListCol: "Список",
      symbolLeadCol: "Лидер",
      symbolFollowCol: "Подписка",
      symbolTags: "Открыт",
      leadingSymbols: "Лидируемые символы",
      detail: "Детали",
      enabled: "Вкл.",
      disabled: "Выкл.",
      held: "Открыта",
      notHeld: "Закрыта",
      weekSettledOrders: "Расчёт за неделю",
      historicalNetPnl: "Общий PnL",
      copyTotalPnl: "Общий PnL копирования",
      historicalSharePayout: "Выплаты доли",
      allOrders: "Все",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "Открытые",
      settledOrdersTab: "Расчётные",
      colInterval: "Длительность",
      colOrderTime: "Время ордера",
      colSelfPnl: "Собств. PnL (с премией)",
      colEstShare: "Ожид. доля (JOULE)",
      traderOrdersTitle: "Лид-ордера {symbol}",
      followOrdersTitle: "Копи-ордера {symbol}",
      selfPnl: "Собств. PnL",
      estimatedShare: "Ожид. доля",
      inProgress: "В процессе",
      followAssets: "PnL по активам",
      byAsset: "По активам",
      followHistory: "Завершённые",
      followStartTime: "Начало: ",
      followEndTime: "Конец: ",
      myPendingApps: "Ожидание",
      cashHeldHint: "Ожид. удержание доли за неделю {cash} JOULE",
      cashHeldFrozen: "Ожид. удержание доли в раунде: {cash} (JOULE, заморожено)",
      followedTrader: "Трейдер",
      followInfo: "Инфо подписки",
      totalPnlJoule: "Общий PnL (JOULE)",
      colTrader: "Трейдер",
      colPrincipal: "Сумма",
      colPnlShare: "PnL (с премией) / доля (JOULE)",
      traderInfo: "Профиль трейдера",
      traderNotFound: "Трейдер не найден",
      followSettingsRelationHint: "Режим копирования, страховка и TP/SL действуют на всю связь и все выбранные символы. Их можно изменить в настройках копирования.",
      followSettingsPrepareHint: "После подтверждения эта конфигурация будет применена ко всем выбранным символам.",
      followOptions: "Параметры подписки",
      noFollowOptions: "Нет параметров подписки~",
      symbolFollowing: "Подписка активна",
      symbolPaused: "На паузе",
      symbolIdle: "Не подписан",
      cancelFollowSymbol: "Отписаться",
      cancelSymbolConfirm: "Отписаться от {symbol}?",
      cancelLastSymbolConfirm: "Это последний символ. Отписка завершит всё отношение. Продолжить?",
      followNow: "Подписаться сейчас",
      followAll: "Подписаться",
      unfollowAll: "Отписаться",
      unfollowAllConfirm: "Отписаться от всех символов этого трейдера? Это завершит всё отношение копирования.",
      followSettings: "Настройки",
      goFollowSettings: "Открыть ›",
      copyAccountBalance: "Счёт копирования: {amount} JOULE",
      orderFollowerCount: "Подписчики по ордеру",
      copyingStatus: "Копируется",
      roleStatusLeading: "Ведёт сделки",
      roleStatusFollowing: "Копирует",
      roleStatusPaused: "Копирование на паузе",
      copyOrderTag: "Копирование",
      copyOpenPositions: "Открытые copy-позиции",
      copyInsuredOrdinary: "Обычная страховка",
      copyUninsured: "Без страховки",
      addSymbolHint: "Этот символ будет добавлен к текущей подписке.",
      myRelationStatus: "Моя подписка",
      latestSettlements: "Последние расчёты",
      resumeRelationFirst: "Отношение полностью на паузе. Возобновите в «Мои подписки» перед действиями по символам.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "Тип",
      colPnlJoule: "PnL (JOULE)",
      tpSl: "Тейк-профит / стоп-лосс",
      takeProfitPhFull: "Пауза после недельной чистой прибыли — необяз. (JOULE)",
      stopLossPhFull: "Пауза после недельного чистого убытка — необяз. (JOULE)",
      confirmModify: "Подтвердить",
      clearSearch: "Назад к рейтингу",
      searchResultHint: "Результаты поиска (нажмите для профиля трейдера)",
      searchEmpty: "Трейдер не найден",
      noMoreSettlements: "Больше нет"
    },
    errors: {
      AUTH_REQUIRED: "Сначала подключите кошелёк",
      AUTH_UNAVAILABLE: "Служба входа временно недоступна. Повторите позже.",
      POSTGRES_REQUIRED: "Сервис временно недоступен. Повторите позже.",
      USER_NOT_FOUND: "Пользователь не найден. Войдите снова и повторите.",
      INVALID_WALLET: "Введите полный адрес кошелька",
      INVALID_QUERY: "Неверный запрос; введите не менее 2 символов",
      INVALID_AMOUNT: "Неверный формат суммы",
      INVALID_PARAM: "Неверные параметры. Проверьте и повторите.",
      INVALID_FOLLOW: "Нельзя копировать собственные сделки",
      TRADER_EXISTS: "Этот кошелёк уже трейдер. Повторная регистрация не нужна.",
      TRADER_FULL: "У этого трейдера достигнут лимит подписчиков",
      TRADER_CANCELLED: "Аккаунт трейдера отменён",
      TRADER_REGISTER_FAILED: "Не удалось зарегистрироваться как трейдер. Повторите позже.",
      TRADER_SETTINGS_FAILED: "Не удалось сохранить настройки трейдера. Повторите позже.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "Недостаточно доступного баланса для заморозки депозита",
      BALANCE_TOO_LOW: "Доступный баланс счёта копирования ниже порога этого трейдера. Сначала переведите с торгового счёта",
      COPY_BALANCE_ZERO: "Баланс счёта копирования равен 0. Сначала переведите с торгового счёта",
      INSUFFICIENT_FUNDS: "Недостаточно средств на торговом счёте для перевода на счёт копирования",
      COPY_TRADE_BALANCE_INSUFFICIENT: "Недостаточно доступного баланса копирования (замороженные суммы нельзя вывести)",
      ACCOUNT_NOT_FOUND: "Ошибка аккаунта. Повторите позже.",
      ACCOUNT_CONFLICT: "Аккаунт обновляется. Повторите позже.",
      FOLLOW_EXISTS: "Вы уже подписаны на этого трейдера",
      FOLLOW_LIMIT: "У вас уже есть активное копирование. Завершите его перед подпиской на другого.",
      FOLLOW_FAILED: "Не удалось начать копирование. Повторите позже.",
      FOLLOW_NOT_FOUND: "Отношение копирования не найдено",
      PAUSE_FAILED: "Не удалось приостановить копирование. Повторите позже.",
      RESUME_FAILED: "Не удалось возобновить копирование. Повторите позже.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "Не удалось завершить копирование. Повторите позже.",
      APPLICATION_NOT_FOUND: "Ожидающая заявка не найдена",
      APPROVE_FAILED: "Не удалось одобрить заявку. Повторите позже.",
      REJECT_FAILED: "Не удалось отклонить заявку. Повторите позже.",
      KICK_FAILED: "Не удалось удалить подписчика. Повторите позже.",
      SETTLEMENT_WINDOW: "Настройки трейдера нельзя менять в окне расчёта",
      CANCEL_FAILED: "Не удалось запросить отмену. Повторите позже.",
      CANCEL_NOT_PENDING: "Нет запроса отмены для отзыва",
      CANCEL_WITHDRAW_FAILED: "Не удалось отозвать отмену. Повторите позже.",
      COPY_SETTINGS_MISSING: "Настройки копитрейдинга не готовы. Повторите позже.",
      INVALID_SYMBOL: "Выберите хотя бы один поддерживаемый символ",
      SYMBOL_NOT_ALLOWED: "Включён символ, не разрешённый этим трейдером",
      TRADER_BALANCE_TOO_LOW: "После заморозки депозита доступного баланса недостаточно для регистрации",
      TIMEOUT: "Операция не удалась. Повторите позже.",
      NETWORK: "Операция не удалась. Повторите позже."
    },
    status: {
      ACTIVE: "Активно",
      PAUSED: "На паузе",
      ENDED: "Завершено",
      PENDING_REVIEW: "Ожидает проверки трейдера",
      CANCEL_PENDING: "Отмена ожидается",
      CANCELLED: "Отменено"
    },
    traderStatus: {
      ACTIVE: "Ведение",
      CANCEL_PENDING: "Выход",
      CANCELLED: "Отменён",
    },
    pauseReason: {
      USER: "Пауза пользователем",
      INSUFFICIENT_BALANCE: "Пауза: недостаточно баланса счёта копирования",
      TAKE_PROFIT: "Сработал тейк-профит",
      STOP_LOSS: "Сработал стоп-лосс",
      TRADER_KICK: "Удалён трейдером",
      SWITCH: "Смена трейдера",
      SETTLEMENT_CLEANUP: "Удалён при недельном расчёте",
      TRADER_CANCEL: "Трейдер отменён"
    },
    followMode: {
      EQUAL: "Равная сумма",
      RATIO: "Коэффициент"
    },
    insuranceMode: {
      FOLLOW: "Как у трейдера",
      ALWAYS_ON: "Всегда вкл.",
      ALWAYS_OFF: "Всегда выкл."
    },
    reviewMode: {
      AUTO: "Автоподписка",
      MANUAL: "Подписка с проверкой"
    },
    applicationStatus: {
      PENDING: "Ожидание",
      APPROVED: "Одобрено",
      REJECTED: "Отклонено",
      CANCELLED: "Отменено",
      PENDING_REVIEW: "Ожидание"
    }
  },}
